import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, ChangeDetectorRef, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';

import { NotificationStoreService, DatastoreService, CommonFunctionsService } from 'src/app/services/index';
import { TranslatorService } from 'src/app/services/translator.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  loggedIn = false;
  meetingRoom = false;
  userName = '';
  activePage = '';

  color = '';
  background = '';
  logo = '';
  pageTitle = '';
  urlLink = '';
  headerText = '';
  footerText = '';
  mobile = false;

  showMenuItems: boolean = false;

  errors = []
  loadIssue = false;
  connectionIssue = false;

  languageForm: any;
  languages: any = undefined;
  language: any = "English (United Kingdom)"
  defaultLan: any;
  // [
  //   {
  //     "name": "english",
  //     "flag": "gb-eng"
  //   }
  // ]
  showLanguageDropdown = false;
  fnScript: any
  lockLanguage = false
  enableTranslation: any;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon') as HTMLLinkElement;

  @ViewChild('languageDropdownEl') languageDropdownEl: ElementRef;
  @ViewChild('languageButton') languageButton: ElementRef;
  constructor(
    private router: Router,
    private dataStore: DatastoreService,
    private notifStore: NotificationStoreService,
    private commonFunctionsService: CommonFunctionsService,
    private formBuilder: FormBuilder,
    public translatorService: TranslatorService,
    private renderer2: Renderer2,
    private cdref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document2: Document,
    private titleService: Title
  ) {

  }

  ngDoCheck() {
    if (this.dataStore.member) {
      this.userName = this.dataStore.member.name;
    } else {
      this.userName = "";
    }

    this.loggedIn = this.dataStore.loggedIn;
    const path = window.location.pathname.split('/');

    this.activePage = path[path.length - 1];



  }

  ngOnInit(): void {

    const config = sessionStorage.getItem('config') as string;
    const configObj = JSON.parse(config) as any;

    // subscribe to session updates for config changes
    this.notifStore.sessionUpdate.subscribe(() => {
      this.loadConfig()
    })

    // throw one in just for preloading
    this.loadConfig()
    if (this.enableTranslation) {
      this.translator()
    }
    // if (/ Android | webOS | iPhone | iPad | iPod | BlackBerry | IEMobile | Opera Mini / i.test(navigator.userAgent)) {
    //   this.mobile = true;
    // } else {
    //   this.mobile = false;
    // }
    this.ngDoCheck()
    if (this.enableTranslation) {

      let languageInfoTable = this.translatorService.languageInfoTable
      // const googleLanguages = [];

      for (let i in languageInfoTable) {
        let flag = languageInfoTable[i]["flag code"]
        if (flag !== "") {
          flag = `./assets/images/flags/4x3/${flag.split(" ")[0]}.svg`
        }
        languageInfoTable[i]["flag"] = flag;
      }
      const finalLanguages: any[] = []
      for (let i in this.translatorService.googleLanguageSupport) {
        const nationOptions = languageInfoTable.filter((x: { [x: string]: string; }) => x["Two letter"] === this.translatorService.googleLanguageSupport[i]["ISO-639 code"])
        if (nationOptions.length > 0) {
          let flagOptions = nationOptions.filter((x: { [x: string]: string; }) => x["flag code"] !== "")
          if (flagOptions.length > 0) {
            const coreFlag: any = flagOptions[0];
            coreFlag.flags = []
            coreFlag.flagI = 0
            coreFlag.flagCount = flagOptions.length
            // console.log(flagOptions)
            for (let i in flagOptions) {
              coreFlag.flags.push(flagOptions[i]["flag"])
            }
            if (coreFlag["Two letter"] === "en") {
              coreFlag.flags = [`./assets/images/flags/4x3/gb.svg`]
              coreFlag.flagCount = 1
            }
            // remove country brackets
            coreFlag.Native = coreFlag.Native.replace(/\([^(]*\)(.*)/g, '')
            // order alphabetically 
            coreFlag.Native = coreFlag.Native[0].toUpperCase() + coreFlag.Native.substr(1).toLowerCase();
            // console.log(coreFlag)
            finalLanguages.push(coreFlag)
            // for (let j in flagOptions) {
            //   finalLanguages.push(flagOptions[j])
            // }
          } else {
            for (let j in nationOptions) {
              finalLanguages.push(nationOptions[j])
            }
          }
        }
      }
      const sortedLanguages = finalLanguages.sort((a, b) => a.Native.localeCompare(b.Native))
      this.languages = sortedLanguages;
      this.defaultLan = sortedLanguages.filter((x: { "Two letter": string; }) => {
        return x["Two letter"] === "en"
      })
      this.checkFlag(sortedLanguages)

      this.renderer2.listen('window', 'click', (e: Event) => {
        const target: any = e.target
        // console.log(target.("class=notranslate",""))
        if (this.languageDropdownEl !== undefined && this.languageButton === undefined) {
          if (!this.languageDropdownEl.nativeElement.contains(target) && !this.lockLanguage) {
            this.showLanguageDropdown = false;
          }
        }
        if (this.languageButton !== undefined) {
          if (this.languageButton.nativeElement.contains(target)) {
            this.showLanguageDropdown = true;
          }
        }
      })

      const wa = setInterval(() => {
        const v: any = window.document.getElementsByClassName("goog-te-combo")
        if (v !== null) {
          if (v[0] !== undefined) {
            if (v[0].value === "") {
              if (this.language !== this.defaultLan) {
                this.language = this.defaultLan
              }
            } else {
              this.language = this.languages.filter((x: { "Two letter": string; }) => {
                return x["Two letter"] === v[0].value
              })[0]
            }
          }
        }

      }, 100);
      // prevents the “Contribute better translation" pop up from showing
      // interval is for waiting till the element is loaded. probably could be done with an observer instead?
      const googlePopupBlocker = setInterval(() => {
        const googlePopup = document.getElementById("goog-gt-");
        if (googlePopup !== null) { // wait till loaded
          var observer = new MutationObserver(function () {
            if (googlePopup.style.visibility != 'hidden') { // if not hidden immediately make it hidden again
              googlePopup.style.visibility = 'hidden'
            }
          });
          observer.observe(googlePopup, { attributes: true, childList: true }); //observe it
          clearInterval(googlePopupBlocker) // we've made the observable, now we no-longer need the interval
        }
      }, 100);
    }

  }

  checkFlag(sortedLanguages: any): any {
    const current = this.getCurrent()
    // ensures the google lan selector exists before we try and make our own one modify it
    // and that we have our language lists all set up
    if (current === null && sortedLanguages !== undefined && sortedLanguages.length > 0) {
      const here = this
      setTimeout(() => {
        here.checkFlag(sortedLanguages)
      }, 500);
    } else {
      // default to english
      let selected = sortedLanguages.filter((x: { "Two letter": string; }) => {
        return x["Two letter"] === "en"
      })
      this.defaultLan = selected[0];
      // check what the google translate is set to atm, if anything, and use that if you find something
      if (current !== null && current !== '') {
        selected = sortedLanguages.filter((x: { [x: string]: any; }) => {
          return x["Two letter"] === current
        })
      }
      if (selected.length > 0) {
        this.language = selected[0]
      } else { // handles some race condition issues
        const here = this
        setTimeout(() => {
          here.checkFlag(sortedLanguages)
        }, 500);
      }

      this.languageForm = true;
      setInterval(() => {
        this.updateFlag()
      }, 1000)
    }

  }


  showFlag(language: any) {
    // console.log(language)
    if (language.flagI !== undefined) {
      // console.log(language.flags[language.flagI])
      return language.flags[language.flagI]
    }
    else return language.flag
  }

  updateFlag() {
    for (let i in this.languages) {
      const language = this.languages[i];
      if (language && language.flagI !== undefined) {
        if (language.flagI < language.flagCount - 1) {
          language.flagI++
        } else {
          language.flagI = 0
        }
      }
    }
  }

  translator() {
    const script = this.renderer2.createElement('script');
    script.type = `text/javascript`;
    script.src = `https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit`;
    this.renderer2.appendChild(this.document2.body, script);

    this.fnScript = this.renderer2.createElement('script');
    this.fnScript.type = 'text/javascript';
    this.fnScript.text = `function googleTranslateElementInit() {
      new google.translate.TranslateElement(
          {pageLanguage: 'sr'},
          'google_translate_element'
      );
    }`;
    this.renderer2.appendChild(this.document2.body, this.fnScript);
  }

  loadConfig() {
    const config = this.dataStore.config;
    if (config) {
      const configJson = JSON.parse(config);
      console.log(configJson)
      this.enableTranslation = configJson.enableTranslation
      this.color = configJson.text_colour;
      this.background = configJson.header_colour;
      this.pageTitle = configJson.page_title;
      this.headerText = configJson.header_text;
      this.footerText = configJson.footer_text;
      this.logo = configJson.logo;
      this.urlLink = configJson.logo_link;

      if (configJson.hasOwnProperty('favicon_link')) {
        this.favIcon.href = configJson.favicon_link;
      }
      this.titleService.setTitle(this.pageTitle);
    }

  }


  myBookings() {
    this.router.navigate(['/mybookings']);
  }

  services() {
    this.router.navigate(['/services']);
  }

  whichSignOut() {
    const config = sessionStorage.getItem('config') as string;
    const configObj = JSON.parse(config) as any;
    this.loggedIn = this.dataStore.loggedIn;
    this.commonFunctionsService.setUserLoggedIn(false);

    if (this.loggedIn) {
      this.signOut();
    }
  }

  signOut() {
    this.loggedIn = false;
    this.userName = '';
    this.commonFunctionsService.logout();
  }

  ssoSignOut() { // Add log out function here
    localStorage.clear();
    this.dataStore.authToken = null;
    this.dataStore.member = null;
    this.dataStore.loggedIn = false;
    this.commonFunctionsService.newBooking();
    this.loggedIn = false;
    this.userName = '';
    this.commonFunctionsService.ssoLogout();
  }

  showMenu() {
    this.showMenuItems = !this.showMenuItems;
  }

  resetApp() {
    this.commonFunctionsService.newBooking();
    this.errors = []
    this.loadIssue = false;
    this.connectionIssue = false;
    this.router.navigate(['/access']);
  }

  change_language(value: any) {
    this.lockLanguage = true
    this.showLanguageDropdown = false;
    this.language = value;
    const v: any = window.document.getElementsByClassName("goog-te-combo")
    if (v !== null) {
      v[0].value = value["Two letter"]
      const evt = new Event("change");
      v[0].dispatchEvent(evt)
    }
    this.lockLanguage = false

  }

  getCurrent() {
    const v: any = window.document.getElementsByClassName("goog-te-combo")
    if (v !== null) {
      if (v[0] !== undefined)
        return v[0].value
    }
    return null;
  }

  goTo(url:string){
    console.log("here",url)
    window.document.location.href = url

  }

}
